import script from "./ModalDeleteTask.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDeleteTask.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDeleteTask.vue?vue&type=style&index=0&id=6ad63834&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad63834"]])

export default __exports__